<template>
  <div class="mb-3">
    <label v-if="label" :for="id" class="form-label">
      <span> {{ label }} </span>
      <span v-if="required" class="text-danger"> {{ required ? '*' : '' }} </span>
      <div v-if="hint" class="d-block fw-light text-secondary lh-1 mb-1 fs-6">
        <small> {{ hint }}</small>
      </div>
    </label>
    <textarea
      :id="id"
      :name="id"
      ref="input"
      v-bind="$attrs"
      :class="['form-control form-control-lg', { 'lpg-error': error }]"
      :value="value"
      :rows="rows"
      :maxlength="maxlength"
      @input="$emit('input', $event.target.value)"
    />
    <small
      v-if="maxlength"
      :class="[
        'mt-1 mx-1 d-block text-end',
        length === maxlength ? 'text-danger fw-bold' : 'text-muted',
      ]"
      >{{ length }} / {{ maxlength }}</small
    >
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `textarea-input-${this._uid}`
      },
    },
    maxlength: {
      type: Number,
    },
    rows: {
      type: Number,
      default: 2,
    },
    value: { type: String, default: '' },
    label: String,
    error: String,
    required: {
      type: Boolean,
      default: false,
    },
    hint: String,
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
  },
  computed: {
    length() {
      return this.value ? this.value.length : 0
    },
  },
}
</script>
